import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-divider',
    templateUrl: './divider.component.html',
    styleUrls: ['./divider.component.scss'],
    standalone: false
})
export class DividerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
